import * as React from "react";

export interface IAgeProps {
  years: number;
  months: number;
  yearsLabel: string;
  monthsLabel: string;
}

export const Age: React.FC<IAgeProps> = ({
  years,
  months,
  yearsLabel,
  monthsLabel,
}) => {
  if (typeof years === "undefined" || typeof months === "undefined") {
    return <span />;
  }

  return (
    <span>
      {years} {yearsLabel} {months} {monthsLabel}
    </span>
  );
};

export default Age;
